import { melodyRequest, publicRequest } from './request'
import MelodyMailings from './mailings'
import MelodyEmails from './emails'
import MelodyEmailTemplates from './email_templates'
import MelodyPeople from './people'
import MelodyUser from './user'
import MelodyStats from './stats'
import MelodyReminders from './reminders'
import MelodyCustomFields from './custom_fields'
import Notes from './notes'
import Cadences from './cadences'
import Tags from './tags'
import Activities from './activities'
import Actions from './actions'
import CrmSyncSettings from './crm_sync_settings'
import TeamEmailSettings from './team_email_settings'
import Accounts from './accounts'
import Groups from './groups'
import Templates from './templates'

import Snippets from './snippets'
import CrmReferences from './crm_references'

import Meetings from './meetings'
import Sentiments from './sentiments'
import EmailReplies from './email_replies'
import CalendarLofting from './loft_calendar_events'
import Me from './me'
import PublicPeople from './public_people'
import Crm from './crm'

export const SIMPLE_EMAIL_REGEX = /.+@.+\..+/

export class Gateway {
  user = new MelodyUser(melodyRequest)
  stats = new MelodyStats(melodyRequest)
  mailings = new MelodyMailings(melodyRequest)
  emails = new MelodyEmails(melodyRequest)
  emailTemplates = new MelodyEmailTemplates(melodyRequest)
  people = new MelodyPeople(melodyRequest)
  reminders = new MelodyReminders(melodyRequest)
  customFields = new MelodyCustomFields(melodyRequest)
  cadences = new Cadences(melodyRequest)
  actions = new Actions(melodyRequest)
  notes = new Notes(melodyRequest)
  tags = new Tags(melodyRequest)
  activities = new Activities(melodyRequest)
  teamEmailSettings = new TeamEmailSettings(melodyRequest)
  crmSyncSettings = new CrmSyncSettings(melodyRequest)
  accounts = new Accounts(melodyRequest)
  groups = new Groups(melodyRequest)
  templates = new Templates(publicRequest)

  snippets = new Snippets(publicRequest)
  crmReferences = new CrmReferences(publicRequest)

  meetings = new Meetings(publicRequest)
  sentiments = new Sentiments(melodyRequest)
  emailReplies = new EmailReplies(publicRequest)
  me = new Me(publicRequest)
  calendarLofting = new CalendarLofting(publicRequest)
  publicPeople = new PublicPeople(publicRequest)
  crm = new Crm(publicRequest)

  watchToken = () => next => action => {
    if (action !== undefined && action.type === 'SET_USER_SESSION') {
      melodyRequest.setBaseUrl(action.auth.environment.melody_api_url)
      publicRequest.setBaseUrl(action.auth.environment.public_api_url)
      this.appUrl = action.auth.environment.app_url
    }
    return next(action)
  }
}

export default new Gateway()
